var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('h2',[_vm._v(_vm._s(new Date(_vm.generalInfo.lastUpdate)))]),_c('Statistic',{attrs:{"countryData":_vm.generalInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }